import React, { useContext, useEffect, useMemo } from "react";
import { CommonService } from "../../services/common/common.service";
import HeaderComponent from "../../components/header/header.component";
import { GlobalContext, ProductsProvider } from "../../store";

import { useTranslation } from "react-i18next";
import ProductsContent from "../../modules/products/components/products-content/products-content.component";
import { ContentLayout } from "../../layouts/content/content.layout";
import PagesHeadComponent from "../../components/pages-head-component/pages-head.component";
import SupportBlockComponent from "../../components/support/support.component";

const ProductsPage = () => {
  const { t } = useTranslation();
  const commonService = useMemo(() => new CommonService(), []);
  const { setPageTitle } = useContext(GlobalContext);

  useEffect(() => {
    const title = t("PAGE_META_TITLES.AI_SOFTWARE_PRODUCTS");
    commonService.setTitle(title);
    setPageTitle(title);
  }, [t, setPageTitle, commonService]);

  return (
    <ProductsProvider>
      <HeaderComponent />
      <ContentLayout>
        <PagesHeadComponent
          title={t("PAGES_HEAD.PRODUCTS_TITLE")}
          subTitle={t("PAGES_HEAD.PRODUCTS_SUB_TITLE")}
        />
        <ProductsContent />
        <SupportBlockComponent />
      </ContentLayout>
    </ProductsProvider>
  );
};
export default ProductsPage;
